import { Box } from "@mui/material";
import { getStatusLabel } from "../../Utils/DecideStatus";
import { getCellStyle } from "../../Utils/DecideColor";
import {
  formatCellValue,
  formatDateForDisplay,
} from "../../Utils/UtilityFunctions";
import StatusBadge from "../../Customers/StatusBadge";
export const staionsColumnData = (
  evse,
  connector,
  StationName,
  StationAddress,
) => {
  const Columns = [
    {
      accessorKey: "stationDetails.stationID",
      header: "Station ID",
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorFn: (stations, index) => `${StationName[index]}`,
      header: "Station Name",
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorFn: (stations, index) => `${StationAddress[index]}`,
      header: "Address",
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorFn: () => "NA",
      header: "Total EVSE",
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorFn: (row) => row.stationDetails?.connectors?.length ?? 0,
      header: "No Of Connectors",
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorKey: "stationDetails.status",
      header: "Status",
      Cell: ({ cell }) => <StatusBadge value={cell.getValue()} />,
    },
    // {
    //     accessorKey: 'stationDetails.adminStatus',
    //     header: 'Admin Action',
    //     Cell: ({ cell }) => (
    //         <StatusBadge value={cell.getValue() === 'Active' ? 'Activate' : 'Deactivate'} />
    //     )
    // },
    // {
    //     accessorKey: 'stationDetails.lastContactAt',
    //     header: 'Operational Status',
    //     Cell: ({ cell }) => {
    //         const lastContact = cell.getValue()

    //         if (!lastContact) {
    //             return <StatusBadge value="Offline" />
    //         }

    //         const lastContactTime = new Date(lastContact).getTime()
    //         const currentTime = new Date().getTime()

    //         const diffInMs = currentTime - lastContactTime
    //         const diffInSeconds = diffInMs / 1000

    //         const status = diffInSeconds <= 60 ? "Online" : "Offline"

    //         return <StatusBadge value={status} />
    //     }
    // }
    {
      accessorFn: (row) => {
        const status = row?.stationDetails?.adminStatus;

        if (!status) return "";
        return status === "Active" ? "Activate" : "Deactivate";
      },
      header: "Admin Action",
      Cell: ({ cell }) => <StatusBadge value={cell.getValue()} />,
    },
    {
      accessorFn: (row) => {
        const lastContact = row?.stationDetails?.lastContactAt;

        if (!lastContact) return "Offline";

        const lastContactTime = new Date(lastContact).getTime();
        const currentTime = new Date().getTime();

        const diffInSeconds = (currentTime - lastContactTime) / 1000;

        return diffInSeconds <= 60 ? "Online" : "Offline";
      },
      header: "Operational Status",
      Cell: ({ cell }) => <StatusBadge value={cell.getValue()} />,
    },
  ];
  return Columns;
};
